import { createUseStyles } from 'react-jss';

export const useChileTaxformStyles = createUseStyles(() => ({
  flex: {
    display: 'flex',
  },
  gap20px: {
    gap: '20px',
  },
}));
